import { useContext } from 'react';
import { AuthContext } from 'src/sdk/auth/AuthProvider';

export const useAuth = () => {
  const { auth } = useContext(AuthContext);
  return auth;
}
